import * as React from 'react';

import { DeviceInfoContext } from '@/contexts/device-info-context';

function FourIcon(props) {
  const { isMobile } = React.useContext(DeviceInfoContext);
  return isMobile ? (
    <>
      <svg width={28} height={28} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <ellipse cx={14} cy={20.829} rx={13.333} ry={6.504} fill='url(#prefix__paint0_linear_211_1705)' />
        <g filter='url(#prefix__filter0_bi_211_1705)'>
          <ellipse cx={14} cy={14} rx={13.333} ry={6.179} fill='#72BF44' fillOpacity={0.3} />
        </g>
        <g filter='url(#prefix__filter1_bi_211_1705)'>
          <ellipse cx={14} cy={7.171} rx={13.333} ry={6.504} fill='#72BF44' fillOpacity={0.3} />
        </g>
        <defs>
          <filter
            id='prefix__filter0_bi_211_1705'
            x={-3.333}
            y={3.821}
            width={34.667}
            height={20.358}
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity={0} result='BackgroundImageFix' />
            <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
            <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_1705' />
            <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_1705' result='shape' />
            <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
            <feOffset dx={0.2} dy={0.1} />
            <feGaussianBlur stdDeviation={0.5} />
            <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
            <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
            <feBlend in2='shape' result='effect2_innerShadow_211_1705' />
          </filter>
          <filter
            id='prefix__filter1_bi_211_1705'
            x={-3.333}
            y={-3.333}
            width={34.667}
            height={21.008}
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity={0} result='BackgroundImageFix' />
            <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
            <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_1705' />
            <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_1705' result='shape' />
            <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
            <feOffset dx={0.2} dy={0.1} />
            <feGaussianBlur stdDeviation={0.5} />
            <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
            <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
            <feBlend in2='shape' result='effect2_innerShadow_211_1705' />
          </filter>
          <linearGradient
            id='prefix__paint0_linear_211_1705'
            x1={0.667}
            y1={14.325}
            x2={22.968}
            y2={9.011}
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#4FB84E' />
            <stop offset={1} stopColor='#2A8640' />
          </linearGradient>
        </defs>
      </svg>
    </>
  ) : (
    <>
      <svg width={40} height={40} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <ellipse cx={20} cy={30.244} rx={20} ry={9.756} fill='url(#prefix__paint0_linear_159_1033)' />
        <g filter='url(#prefix__filter0_bi_159_1033)'>
          <ellipse cx={20} cy={20} rx={20} ry={9.268} fill='#72BF44' fillOpacity={0.3} />
        </g>
        <g filter='url(#prefix__filter1_bi_159_1033)'>
          <ellipse cx={20} cy={9.756} rx={20} ry={9.756} fill='#72BF44' fillOpacity={0.3} />
        </g>
        <defs>
          <filter
            id='prefix__filter0_bi_159_1033'
            x={-4}
            y={6.731}
            width={48}
            height={26.537}
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity={0} result='BackgroundImageFix' />
            <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
            <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_159_1033' />
            <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_159_1033' result='shape' />
            <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
            <feOffset dx={0.2} dy={0.1} />
            <feGaussianBlur stdDeviation={0.5} />
            <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
            <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
            <feBlend in2='shape' result='effect2_innerShadow_159_1033' />
          </filter>
          <filter
            id='prefix__filter1_bi_159_1033'
            x={-4}
            y={-4}
            width={48}
            height={27.512}
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'
          >
            <feFlood floodOpacity={0} result='BackgroundImageFix' />
            <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
            <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_159_1033' />
            <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_159_1033' result='shape' />
            <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
            <feOffset dx={0.2} dy={0.1} />
            <feGaussianBlur stdDeviation={0.5} />
            <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
            <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
            <feBlend in2='shape' result='effect2_innerShadow_159_1033' />
          </filter>
          <linearGradient
            id='prefix__paint0_linear_159_1033'
            x1={0}
            y1={20.488}
            x2={33.451}
            y2={12.517}
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#4FB84E' />
            <stop offset={1} stopColor='#2A8640' />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}

export default FourIcon;
